import React from 'react';
import {useTranslation} from "react-i18next";

const ShareResult = ({ oid }) => {
    const { t } = useTranslation();
  const currentBaseUrl = window.location.origin;
  return (
    <div className={'model'}>
      <CopyInput label={`${t("Link")}`} value={`${currentBaseUrl}/${oid}`} />
      <br/>
      <CopyInput label="Markdown" value={`[Run](${currentBaseUrl}/${oid})`} />
    </div>
  );
};
const CopyInput = ({ label, value }) => {
  const { t } = useTranslation();
  const handleCopy = () => {
    const input = document.getElementById(label);
    input.select();
    document.execCommand('copy');
  };
  return (
    <div className={'copy-input'}>
      <label htmlFor={label}>{label}:</label>
      <input id={label} type="text" value={value} readOnly />
      <button onClick={handleCopy}>{t("Copy")}</button>
    </div>
  );
};
export default ShareResult;